import LocalizedStrings from 'localized-strings';

/**
 * @todo [multi-receipt] Uncomment plural translations
 */
const locales = new LocalizedStrings({
  en: {
    or: 'Or',
    title: 'Link Shine invoice',
    // title: 'Link Shine invoices',
  },
  fr: {
    or: 'Ou',
    title: 'Lier une facture Shine',
    // title: 'Lier des factures Shine',
  },
} as const);

export default locales;
